(function () {
    'use strict';

    angular.module('app.users', [
        'app.core',
        'app.widgets'
    ]);
})();
